import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";

import Templates from "./templates";

export const TemplatesDialog = ({ isOpen, title, handleClose, handleConfirm, varietyid }) => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Dialog open={isOpen} onClose={handleClose} fullScreen={true}>
        <DialogContent>
          <Button variant="contained" color="secondary" style={{ margin: "2px" }} onClick={handleClose}>
            close
          </Button>

          {loading && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
              <LinearProgress style={{ width: '100%' }} />
            </div>
          )}

          <Templates
            maintenancemode={false}
            handleAddTemplateLines={handleConfirm}
            varietyid={varietyid}
            setLoading={setLoading}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};